const state = {
  /** 注册来源 */
  registerSource: undefined,
  /** 销售码 */
  sc: undefined
}

const mutations = {
  /** 设置卖家信息 */
  setRegisterSource(state, newVal) {
    state.registerSource = newVal;
  },
  /** 设置销售绑定码 */
  setSaleCode(state, newVal) {
    state.sc = newVal;
  }
}

export default ({
  namespaced: true,
  state,
  mutations
})
